import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-bdde36ee")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_t = _resolveComponent("t")
  const _component_Matrix = _resolveComponent("Matrix")
  const _component_Holder = _resolveComponent("Holder")

  return (_openBlock(), _createBlock(_component_Holder, {
    content: _ctx.list,
    "skeleton-repeat": 4
  }, {
    default: _withId(() => [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, ([key, group]) => {
        return (_openBlock(), _createBlock("div", {
          key: key,
          class: "group py-8"
        }, [
          _createVNode(_component_t, {
            as: "p",
            path: _ctx.types[key].label,
            class: "group__name f-bold"
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.types[key].labelDefault), 1)
            ]),
            _: 2
          }, 1032, ["path"]),
          _createVNode(_component_Matrix, {
            list: group,
            column: 2,
            identify: v => v.code
          }, {
            default: _withId(({ item }) => [
              _renderSlot(_ctx.$slots, "default", { symbol: item }, undefined, true)
            ]),
            _: 2
          }, 1032, ["list", "identify"])
        ]))
      }), 128))
    ]),
    _: 1
  }, 8, ["content"]))
})